import EventManager from "../eventManager.js";
import Config from "../config.js";

export default class BasketManager extends EventManager {

    constructor(options) {
        super();

        this.settings = $.extend({
          }, {
            step: 0,
            animationQueue: function () {

              // jQuery queues up animations on each dom element (/ jquery object)
              // We want to queue up animations over different dom elements so
              // use a jquery object on a blank element
              let animationQueue = $({})

              return {
                add: function (animationFunctionContext, animationFunction) {
                  let args = $.makeArray(arguments).slice(2);
                  animationQueue.queue(function (next) {
                      $.when(animationFunction.apply(animationFunctionContext, args)).done(next)
                  })
                }
              }
            }()
          }, options);

        let GoogleAnalyticsEvent = require('../tracking/googleAnalyticsEvent.js').default;

        this.gaEvent = new GoogleAnalyticsEvent({category: 'Panier'});

        let Loader = require('../loader/loader.js').default;

        if (this.settings.step === 0) {
          // try to auto-detect
          if ($('table.basket').length > 0) {
            this.settings.step = 1
          } else if ($('div.panier .contenu').length > 0) {
            this.settings.step = 2
          }
        }

        switch (this.settings.step) {
          // Step 1
          case 1:
            // this.gaEnhancedCommerce.send('setAction', 'checkout', {'step': 1, 'option': 'Vue panier'});
            //this.gaEvent.send({action: 'Vue panier'});
            $('form[name=valider-panier]').submit(() => {
              if ($('form[name=valider-panier] input[name=valid_cgv]').is(':checked')) {
                return true
              } else {
                window.app.getPopupManagerInstance().info("Vous devez valider nos conditions générales de ventes en cochant la case «j\'accepte les conditions générales de ventes» juste au dessus du bouton «COMMANDER», avant de pouvoir continuer.")
                return false
              }
            })

            import('./basket.js')
              .then(ClassDef => ClassDef.default)
              .then(Basket => {
                this.basket = new Basket({containerSelector: 'table.basket'})
                this.basket
                  .addListener('reset', () => {
                    this.gaEvent.send({action: 'click', label:'Vider'})
                  })
                  .addListener('quantityChanged', (basket, $productList) => {
                    this.gaEvent.send({action: 'click', label:'Modif Quantite'})
                    this.gaEvent.send({
                      action: 'checkout_progress',
                      checkout_step: 1,
                      items: $productList.find('> tr[data-idartref]').toArray().map( tr => {
                        let $tr = $(tr)
                        return {
                          "id": $tr.data('idart'),
                          "name": $tr.data('name'),
                          "list_name": "Panier",
                          "brand":  $tr.data('brand'),
                          "category": $tr.data('category'),
                          "variant": $tr.data('variant'),
                          "list_position": $tr.data('list_position'),
                          "quantity": $tr.data('quantity'),
                          "price": $tr.data('price')
                        }
                      } ),
                      coupon: basket.$container.find('.code_promo .utilise [data-coupon]').data('coupon')
                    })
                    
                  })
                  .addListener('init', (basket, $productList) => {
                    this.gaEvent.send({
                      action: 'begin_checkout',
                      checkout_step: 1,
                      items: $productList.find('> tr[data-idartref]').toArray().map( tr => {
                        let $tr = $(tr)
                        return {
                          "id": $tr.data('idart'),
                          "name": $tr.data('name'),
                          "list_name": "Panier",
                          "brand":  $tr.data('brand'),
                          "category": $tr.data('category'),
                          "variant": $tr.data('variant'),
                          "list_position": $tr.data('list_position'),
                          "quantity": $tr.data('quantity'),
                          "price": $tr.data('price')
                        }
                      } ),
                      coupon: basket.$container.find('.code_promo .utilise [data-coupon]').data('coupon')
                    })
                  })
                  .addListener('remove_element', (basket, $product) => {
                    this.gaEvent.send({
                      action: 'remove_from_cart',
                      checkout_step: 1,
                      items: [{
                        "id": $product.data('idart'),
                        "name": $product.data('name'),
                        "list_name": "Panier",
                        "brand":  $product.data('brand'),
                        "category": $product.data('category'),
                        "variant": $product.data('variant'),
                        "list_position": $product.data('list_position'),
                        "quantity": $product.data('quantity'),
                        "price": $product.data('price')
                      }]
                    })
                  })
              });

            break

          // Step 2
          case 2:
            this.loader = new Loader($('div.panier .contenu'));

            const AddressManager = require('../address/addressManager.js').default;
            this.addressesManager = new AddressManager();

            this.addressesManager.addListener('select', this.onAddressSelected.bind(this));
            this.addressesManager.addListener('change', this.onWaitAddressChange.bind(this));

            const ShippingManager = require('../shipping/shippingManager.js').default;
            this.shippingManager = new ShippingManager({ animationQueue: this.settings.animationQueue });

            this.addressesManager.get(this.onAddressSelected.bind(this, this.addressesManager));

            // this.$paiementContainer = $('<div/>', {id: 'paiementContainer'}).insertAfter(this.shippingManager.$container);

            const PaymentManager = require('../payment/paymentManager.js').default;
            this.paymentManager = new PaymentManager({
                globalLoader: this.loader
            });

            this.paymentManager.addListener('validate',  (widget, mode, card) => {

                    let label = '';

                    switch (mode.id) {

                        case '1':
                            label = 'Paiement par chèque';
                            break;

                        case '2':
                            if (card && card != '') {
                                label = 'Paiement par CB enregistrée';
                            } else {
                                label = `Paiement par CB non enregistrée (${mode.options && mode.options.saveCard ? 'avec' : 'sans'} enregistrement)`;
                            }
                        break;

                        case '3':
                            label = 'Paiement par virement';
                            break;

                        // All other checkout types
                        default:
                            label = 'Paiement de type inconu';
                            break;
                    }

                    // this.gaEnhancedCommerce.send('setAction', 'checkout', {'step': 4, 'option': label});
                    this.gaEvent.send({
                      action: 'set_checkout_option',
                      checkout_step: 4,
                      checkout_option: "Mode de paiement sélectionné",
                      value: label
                    })
                    this.gaEvent.send({
                      action: 'paiement',
                      label: label
                    })

                } );

            this.shippingManager.addListener('validate', () => {
              let _this = this
              this.settings.animationQueue.add( $('html, body') , $.fn.animate, {
                   get scrollTop() { return _this.paymentManager.$container.prevAll('h2:first').offset().top - Config.headerHeightMobile }
                  },
                  'slow'
                )

              this.paymentManager.update()
            });
            this.shippingManager.addListener('validate', () => {
                // this.gaEnhancedCommerce.send('setAction', 'checkout', {'step': 3, 'option': 'Mode(s) de livraison s�lectionn�(s)'});
                // this.gaEvent.send({action: 'mode de livraison validé'});
                this.gaEvent.send({
                  action: 'set_checkout_option',
                  checkout_step: 3,
                  checkout_option: "Mode(s) de livraison sélectionné(s)",
                  // "value": "USPS"
                })
                this.gaEvent.send({
                  action: 'mode de livraison validé'
                })
            });

            this.shippingManager.addListener('unvalidate', this.paymentManager.unvalidate.bind(this.paymentManager));
            break
        }
    }

    onAddressSelected(widget, address) {
        this.shippingManager.updateAddress(address);
        this.gaEvent.send({
          action: 'set_checkout_option',
          checkout_step: 2,
          checkout_option: "Adresse choisie",
          // "value": "USPS"
        });
        this.gaEvent.send({action: 'addresse validée'});

        // this.gaEnhancedCommerce.send('setAction', 'checkout', {'step': 2, 'option': 'Adresse choisie'});
        // this.gaEvent.send({action: 'addresse validée'});
    }

    onWaitAddressChange() {
        this.shippingManager.waitReload();
    }

    addProduct(idArt, idArtRef, idRub, quantity, type, merchantId) {

        return new Promise((resolve, reject) => {

          if (idArtRef === "" || idArtRef === null || idArtRef <= 0) {
              window.app.getNotificationManagerInstance().info('', {title: "Veuillez choisir l'option du produit", shape: 'banner',  position: 'top', type: 'error'});
              reject();
          }
          $.get("core/ajout_produit.php", {
              id_art_ref: idArtRef,
              id_article: idArt,
              rubrique: idRub,
              qt: quantity,
              type: type,
              access: 'ajax',
              id_merchant: merchantId,
              _format: 'json'
            }).done(response => {
              let title = '';
              let content = '';
              if (response.errorMessage.length > 0 || response.quantityAdded === 0) {
                  title = "Impossible d'ajouter ce produit &agrave; votre panier !";
                  content = response.errorMessage;
              } else {

                this.gaEvent.send({
                  action: 'add_to_cart',
                  checkout_step: 1,
                  items: [{
                    "id": idArt+"."+idArtRef,
                    "name": response.internalLabel,
                    "list_name": "Panier",
                    "brand": response.brand,
                    "category": response.internalCategory,
                    "variant": response.internalProductLabel,
                    "list_position": 1,
                    "quantity": quantity,
                    "price": response.price
                  }]
                });
                
                fbq('track', 'AddToCart', {
                    content_name: response.internalLabel, 
                    content_category: response.internalCategory,
                    content_ids: [idArt+"."+idArtRef],
                    content_type: 'product',
                    value: response.price,
                    currency: 'EUR' 
                });
                
                    gtag('event', 'conversion', {
                        'send_to': 'AW-1067444677/5TyCCLWe9foCEMXT__wD',
                        'value': response.price,
                        'currency': 'EUR'
                    });
                

                title = response.quantityAdded > 1
                  ? "Les articles ont bien &eacute;t&eacute; ajout&eacute;s &agrave; votre panier <i class=\"fa fa-check\" aria-hidden=\"true\"></i>"
                  : "L'article a bien &eacute;t&eacute; ajout&eacute; &agrave; votre panier <i class=\"fa fa-check\" aria-hidden=\"true\"></i>"
                content = null
              }

              window.app.getNotificationManagerInstance().info(content, {
                title: title,
                shape: 'banner',
                position: 'top',
                type: response.errorMessage.length > 0 || response.quantityAdded === 0 ? 'error' : 'info'
              })

              resolve({ idArtRef: idArtRef, quantity: response.quantityAdded })

              if (idRub == "listcourse" && this.basket) {
                this.basket.refreshProducts()
              } else {
                this.refreshSummary()
              }

            }).fail(error => {
              window.app.getNotificationManagerInstance().info(content, {
                title: 'Désolé, une erreur est survenue lors de l\'ajout...',
                shape: 'banner',
                position: 'top',
                type: 'error'
              })
              reject(error)
            })
        })
    }

    refreshSummary () {
        $.get("core/ajax/ajax_quantite_panier.php", {
            _format: 'json'
          }).done(data => {
            let $cp = $("#countpanier");
            if (data.quantity == 0) {
                $cp.css("display", "none");
            } else {
                $cp.css("display", "inline");
                $cp.html(data.quantity);
            }

            if (data.total != 0) {
              $('#amountpanier').html(data.total)
            }

            if (data.quantity > 0) {
              $('#nbArticlePanier').html(data.quantity)
            }

            // Don't know what it is...
            // TODO : shed the light on it...
            for (let article of data.ret) {
                article = article.split('-');
                if ($("#in_" + article[0] + "_" + article[1])) {
                    $("#in_" + article[0] + "_" + article[1]).html(article[2]);
                }
            }
        })
    }
}
